{
  "actions": {
    "cancel": "Cancelar",
    "create": "Crear",
    "save": "Guardar",
    "link": "Vincular",
    "unlink": "Desvincular"
  },
  "toasts": {
    "lessonCreated": "Clase creada correctamente",
    "lessonCreateError": "Error al crear la clase",
    "moduleCreated": "Módulo creado correctamente",
    "moduleCreateError": "Error al crear el módulo",
    "lessonDeleted": "Clase eliminada",
    "lessonDeleteError": "Error al eliminar la clase",
    "moduleDeleted": "Módulo eliminado",
    "moduleDeleteError": "Error al eliminar el módulo",
    "courseLinked": "Módulo vinculado al curso",
    "courseLinkError": "Error al vincular el módulo al curso",
    "courseUnlinked": "Módulo desvinculado del curso",
    "courseUnlinkError": "Error al desvincular el módulo del curso",
    "lessonLinked": "Clase vinculada al módulo",
    "lessonLinkError": "Error al vincular la clase",
    "lessonUnlinked": "Clase desvinculada del módulo",
    "lessonUnlinkError": "Error al desvincular la clase",
    "lessonMoved": "Clase movida correctamente",
    "lessonMoveError": "Error al mover la clase",
    "lessonsReorderError": "Error al reordenar las clases",
    "lessonUpdated": "Clase actualizada",
    "lessonUpdateError": "Error al actualizar la clase",
    "moduleUpdated": "Módulo actualizado",
    "moduleUpdateError": "Error al actualizar el módulo"
  },
  "lessonTypes": {
    "video": "Video",
    "text": "Texto",
    "quiz": "Cuestionario",
    "assignment": "Actividad",
    "live": "En vivo"
  },
  "list": {
    "title": "Módulos",
    "totalRegistered_one": "{{count}} módulo registrado",
    "totalRegistered_zero": "{{count}} módulos registrados",
    "totalRegistered_other": "{{count}} módulos registrados",
    "subtitle": "Gestiona módulos, submódulos y clases",
    "newModule": "Nuevo módulo",
    "searchPlaceholder": "Buscar módulos...",
    "pagination": {
      "showing": "Mostrando <bold>{{from}}</bold> – <bold>{{to}}</bold> de <bold>{{total}}</bold> módulos",
      "previous": "Anterior",
      "next": "Siguiente"
    }
  },
  "table": {
    "loading": "Cargando módulos...",
    "empty": {
      "title": "No se encontró ningún módulo",
      "searchHint": "Prueba con otra búsqueda",
      "createHint": "Crea tu primer módulo para organizar las clases"
    },
    "columns": {
      "thumb": "Miniatura",
      "name": "Nombre",
      "lessons": "Clases",
      "courses": "Cursos",
      "actions": "Acciones"
    }
  },
  "row": {
    "edit": "Editar módulo",
    "delete": "Eliminar módulo",
    "deleteConfirm": {
      "title": "Eliminar módulo",
      "description": "¿Seguro que quieres eliminar \"{{title}}\"? Esta acción no se puede deshacer.",
      "confirm": "Eliminar"
    }
  },
  "moduleForm": {
    "newModule": "Nuevo módulo",
    "newSubModule": "Nuevo submódulo",
    "name": "Nombre",
    "namePlaceholder": "Nombre del módulo",
    "description": "Descripción",
    "descriptionPlaceholder": "Descripción (opcional)",
    "thumbnail": "Miniatura"
  },
  "edit": {
    "loading": "Cargando módulo...",
    "notFound": "Módulo no encontrado",
    "backToModules": "Volver a módulos",
    "modules": "Módulos",
    "subModuleOf": "Submódulo de {{title}}",
    "tabs": {
      "basic": "Información",
      "content": "Contenido",
      "community": "Comunidad"
    }
  },
  "content": {
    "newLesson": "Nueva clase",
    "linkLesson": "Vincular clase",
    "linkCourse": "Vincular a curso",
    "lessonsCount": "Clases ({{count}})"
  },
  "community": {
    "unavailable": {
      "locked": "escaparate bloqueado",
      "noPosts": "no admite publicaciones"
    },
    "notConfigured": {
      "title": "Comunidad no configurada",
      "description": "Define la variable <code>{{variable}}</code> en el backend y reinicia el servidor para habilitar la vinculación entre rutas y espacios de la comunidad."
    },
    "spaceLabel": "Espacio de la comunidad",
    "loadingSpaces": "Cargando espacios...",
    "chooseSpace": "Elige un espacio",
    "inherit": "Heredar del curso",
    "help": "Elegir un espacio aquí sobrescribe, solo para las clases de este módulo, el espacio definido en el curso. Usa \"Heredar del curso\" para volver al valor predeterminado.",
    "empty": "No se encontró ningún espacio en la comunidad. Crea un espacio allí para poder vincularlo aquí."
  },
  "lessonList": {
    "empty": "No hay clases en este módulo",
    "columns": {
      "title": "Título",
      "type": "Tipo",
      "createdAt": "Creado el",
      "actions": "Acciones"
    }
  },
  "lessonRow": {
    "edit": "Editar clase",
    "move": "Mover a otro módulo",
    "delete": "Eliminar clase",
    "deleteConfirm": {
      "title": "Eliminar clase",
      "description": "¿Seguro que quieres eliminar \"{{title}}\"?",
      "confirm": "Eliminar"
    }
  },
  "linkedCourses": {
    "title": "Cursos vinculados",
    "unlink": "Quitar vínculo"
  },
  "subModules": {
    "title": "Submódulos",
    "add": "Submódulo",
    "empty": "Ningún submódulo",
    "edit": "Editar submódulo",
    "delete": "Eliminar submódulo",
    "lessonCount_one": "{{count}} clase",
    "lessonCount_zero": "{{count}} clases",
    "lessonCount_other": "{{count}} clases",
    "deleteConfirm": {
      "title": "Eliminar submódulo",
      "description": "¿Seguro que quieres eliminar \"{{title}}\"? Esta acción no se puede deshacer.",
      "confirm": "Eliminar"
    }
  },
  "lessonForm": {
    "newTitle": "Nueva clase",
    "editTitle": "Editar clase",
    "title": "Título",
    "titlePlaceholder": "Título de la clase",
    "type": "Tipo",
    "description": "Descripción",
    "descriptionPlaceholder": "Descripción (opcional)",
    "content": "Contenido",
    "contentPlaceholder": "Contenido de la clase..."
  },
  "linkCourse": {
    "title": "Vincular a curso",
    "searchPlaceholder": "Buscar cursos...",
    "notFound": "No se encontró ningún curso",
    "noPublished": "No hay cursos publicados"
  },
  "linkLesson": {
    "title": "Vincular clase existente",
    "searchPlaceholder": "Buscar clases...",
    "notFound": "No se encontró ninguna clase",
    "typeToSearch": "Escribe para buscar"
  },
  "moveLesson": {
    "title": "Mover clase",
    "selectTarget": "Selecciona el módulo de destino",
    "noModules": "No hay módulos disponibles",
    "moving": "Moviendo..."
  },
  "convertCourse": {
    "error": "Error al convertir el curso en módulo",
    "title": "Convertir curso en módulo",
    "description": "Transformar \"{{title}}\" en un módulo",
    "warningTitle": "Atención",
    "warningDescription": "El curso se convertirá en un módulo y se archivará. Todas las clases se conservarán dentro del nuevo módulo.",
    "stats": "$t(adminModules:convertCourse.modulesCount, {\"count\": {{modules}} }) · $t(adminModules:convertCourse.lessonsCount, {\"count\": {{lessons}} }) · $t(adminModules:convertCourse.studentsCount, {\"count\": {{students}} })",
    "modulesCount_one": "{{count}} módulo",
    "modulesCount_zero": "{{count}} módulos",
    "modulesCount_other": "{{count}} módulos",
    "lessonsCount_one": "{{count}} clase",
    "lessonsCount_zero": "{{count}} clases",
    "lessonsCount_other": "{{count}} clases",
    "studentsCount_one": "{{count}} alumno",
    "studentsCount_zero": "{{count}} alumnos",
    "studentsCount_other": "{{count}} alumnos",
    "targetLabel": "Vincular al curso (opcional)",
    "targetSearchPlaceholder": "Buscar curso de destino...",
    "noTarget": "Ninguno (solo convertir)",
    "notFound": "No se encontró ningún curso",
    "targetHelp": "Si lo seleccionas, el módulo creado se vinculará automáticamente a este curso",
    "submit": "Convertir"
  },
  "videoUpload": {
    "label": "Video de la clase",
    "gumletLinked": "Video de Gumlet vinculado",
    "unsupportedFormat": "Formato no admitido. Usa MP4, WebM, MOV o AVI.",
    "tooLarge": "Video demasiado grande ({{size}}). Máx.: 5GB",
    "uploaded": "Video subido correctamente",
    "noUrl": "No se pudo obtener la URL del video",
    "uploadError": "Error al subir el video",
    "previewTitle": "Vista previa del video",
    "gumletId": "ID de Gumlet: {{id}}",
    "directUpload": "Subida directa",
    "remove": "Quitar video",
    "gumletPlaceholder": "Pega el ID del video de Gumlet",
    "invalidId": "ID no válido. Debe tener 24 caracteres hexadecimales.",
    "previewUrl": "Vista previa: {{url}}",
    "showDirectUpload": "O subir un archivo directamente",
    "directUploadTitle": "Subida directa (S3)",
    "uploading": "Subiendo video...",
    "dropHint": "Arrastra o haz clic para seleccionar (MP4, WebM, MOV, AVI - máx. 5GB)",
    "linkTitle": "Enlace del video (YouTube, Vimeo o Panda Video)",
    "linkPlaceholder": "Pega el enlace del video",
    "linkInvalid": "Enlace no reconocido. Usa un enlace de YouTube, Vimeo o Panda Video.",
    "linkDetected": "Video de {{provider}} detectado",
    "linkLinked": "Video vinculado",
    "linkedFrom": "Reproduciendo en el player del área · {{provider}}",
    "gumletTitle": "O usa un video alojado en Gumlet",
    "streamTitle": "Video con streaming protegido (recomendado)"
  },
  "quizForm": {
    "newTitle": "Nuevo cuestionario",
    "editTitle": "Editar cuestionario",
    "description": "Configura las preguntas del cuestionario",
    "basicInfo": "Información básica",
    "settings": "Configuración",
    "submitCreate": "Crear cuestionario",
    "submitUpdate": "Actualizar cuestionario",
    "validation": {
      "optionTextRequired": "El texto de la opción es obligatorio",
      "questionRequired": "La pregunta es obligatoria",
      "pointsMin": "Los puntos deben ser mayores que 0",
      "optionsMin": "Se necesita al menos una opción",
      "titleRequired": "El título es obligatorio",
      "timeLimitMin": "El tiempo límite debe ser mayor que 0",
      "passingScoreRange": "La nota debe estar entre 0 y 100",
      "maxRetriesMin": "El máximo de intentos debe ser mayor que 0",
      "questionsMin": "Se necesita al menos una pregunta"
    },
    "fields": {
      "title": "Título *",
      "titlePlaceholder": "Ej.: Evaluación del módulo 1",
      "description": "Descripción",
      "descriptionPlaceholder": "Describe el objetivo de esta evaluación",
      "instructions": "Instrucciones",
      "instructionsPlaceholder": "Instrucciones específicas para los alumnos",
      "passingScore": "Nota mínima (%)",
      "timeLimit": "Tiempo límite (minutos)",
      "timeLimitPlaceholder": "Déjalo vacío para no poner límite",
      "allowRetries": "Permitir reintentos",
      "allowRetriesHelp": "Los alumnos pueden repetir la evaluación",
      "showResults": "Mostrar resultados",
      "showResultsHelp": "Mostrar la nota al terminar",
      "showCorrectAnswer": "Mostrar respuestas correctas",
      "showCorrectAnswerHelp": "Mostrar las soluciones al terminar",
      "randomizeOrder": "Orden aleatorio",
      "randomizeOrderHelp": "Mezclar preguntas y opciones",
      "maxRetries": "Máximo de intentos",
      "maxRetriesPlaceholder": "Déjalo vacío para ilimitado"
    },
    "questions": {
      "title": "Preguntas",
      "add": "Añadir pregunta",
      "emptyTitle": "No hay preguntas creadas",
      "emptyDescription": "Añade preguntas para crear tu cuestionario",
      "first": "Primera pregunta",
      "question": "Pregunta *",
      "questionPlaceholder": "Escribe tu pregunta aquí...",
      "points": "Puntos",
      "explanation": "Explicación (opcional)",
      "explanationPlaceholder": "Explicación que se mostrará después de la respuesta",
      "options": "Opciones de respuesta",
      "addOption": "Añadir opción",
      "true": "Verdadero",
      "false": "Falso",
      "optionPlaceholder": "Texto de la opción"
    },
    "questionTypes": {
      "multipleChoice": "Opción múltiple",
      "trueFalse": "Verdadero/Falso",
      "essay": "Desarrollo"
    }
  },
  "quizStats": {
    "passed": "Aprobados",
    "failed": "Suspendidos",
    "attempts": "Intentos",
    "title": "Estadísticas: {{title}}",
    "description": "Estadísticas de respuestas del cuestionario",
    "totalAttempts": "Total de intentos",
    "totalAttemptsHelp": "Intentos realizados",
    "passRate": "Tasa de aprobación",
    "passRateHelp": "{{passed}} de {{total}} aprobados",
    "averageScore": "Nota media",
    "averageScoreHelp": "Media general de los intentos",
    "passedHelp": "Intentos aprobados",
    "details": "Detalles del cuestionario",
    "questions": "Preguntas",
    "questionsCount_one": "{{count}} pregunta",
    "questionsCount_zero": "{{count}} preguntas",
    "questionsCount_other": "{{count}} preguntas",
    "passingScore": "Nota mínima",
    "timeLimit": "Tiempo límite",
    "minutes_one": "{{count}} minuto",
    "minutes_zero": "{{count}} minutos",
    "minutes_other": "{{count}} minutos",
    "retries": "Reintentos",
    "maxRetries": "Máximo {{max}}",
    "unlimited": "Ilimitados",
    "notAllowed": "No permitidos",
    "questionOrder": "Orden de las preguntas",
    "random": "Aleatorio",
    "fixed": "Fijo",
    "results": "Resultados",
    "showScore": "Mostrar nota",
    "hideScore": "Ocultar nota",
    "showAnswerKey": "Mostrar soluciones",
    "distribution": "Distribución de resultados",
    "passedCount": "Aprobados ({{value}})",
    "failedCount": "Suspendidos ({{value}})",
    "summary": "Resumen general",
    "emptyTitle": "No hay intentos registrados",
    "emptyDescription": "Ningún alumno ha respondido aún este cuestionario."
  }
}
